import { differenceInMinutes } from 'date-fns';

const expectedWaitTimeFormats: Record<string, string> = {
  en: 'h[h] m[m]',
  es: 'h[h] m[m]',
  fr: 'h[h] m[m]',
  ko: 'h[시간] m[분]',
  pl: 'h[g] m[m]',
  'pt-br': 'h[h] m[m]',
  ru: 'h[ч] m[м]',
  'zh-cn': 'h[小时] m[分钟]',
};

const formatDuration = (minutes: number, locale: string): string => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;

  let format = expectedWaitTimeFormats[locale] || expectedWaitTimeFormats['en'];

  if (hours === 0) {
    format = format.replace(/h\[([^\]]+)\]/, '');
  } else {
    format = format.replace(/h\[([^\]]+)\]/, `${hours}$1`);
  }

  return format.replace(/m\[([^\]]+)\]/, `${mins}$1`);
};

/**
 * Return the localized duration based on passed in UTC datetime and locale.
 *
 * @param datetime ISO 8601 string (UTC)
 * @param locale locale string (e.g. "en", "fr", "zh-cn")
 * @returns null | string
 */
export const localizeWaitTime = (
  datetime: string | null,
  locale: string,
): string | null => {
  if (!datetime) {
    return null;
  }

  const nowUtc = new Date();
  const targetUtc = new Date(datetime);

  let diff = differenceInMinutes(targetUtc, nowUtc);
  diff = Math.max(diff, 0);

  const step = 5;
  const roundBias = 2.5;
  const lower = Math.floor(diff / step) * step;
  const upper = lower + step;

  const roundedWaitTime = diff - lower < roundBias ? lower : upper;

  return formatDuration(roundedWaitTime, locale);
};
